import React, { useState } from "react";
import edit from "../../assets/icons/edit.svg";
import save from "../../assets/icons/save.svg";
import deleteIco from "../../assets/icons/delete.svg";
import deleteIcoColor from "../../assets/icons/deleteicon.svg";
import saveColor from "../../assets/icons/saveColor.svg";

const EditableDropdown = (props) => {
  const initialOptions = ["Option 1", "Option 2", "Option 3"];
  // const [options, setOptions] = useState(props.data);
  const [selectedOptionIndex, setSelectedOptionIndex] = useState(null);

  const handleEdit = (index) => {
    setSelectedOptionIndex(index);
    props.setEditMode(true);
    props.setEditedOption(props.data[index]);
    props.setNewFeatureColumn(false);
  };

  const handleSave = () => {
    if (selectedOptionIndex !== null) {
      const updatedOptions = [...props.data];
      updatedOptions[selectedOptionIndex] = [props.editedOption];
      props.setExcelData(updatedOptions);
      setSelectedOptionIndex(null);
      props.setEditMode(false);
      props.setEditedOption("");
      props.setNewFeatureColumn(false);
    }
  };

  const handleCancel = () => {
    setSelectedOptionIndex(null);
    props.setEditMode(false);
    props.setEditedOption("");
    props.setNewFeatureColumn(false);
  };

  const handleDelete = (index) => {
    if (index >= 0 && index < props.data.length) {
      const updatedOptions = [...props.data];
      updatedOptions.splice(index, 1);
      props.setExcelData(updatedOptions);

      const updatedExcelData = [...props.data];
      updatedExcelData.splice(index, 1);
      props.setExcelData(updatedExcelData);
      props.setEditMode(false);
    }
  };
  const handleAddFeature = () => {
    if (props.editedOption !== "") {
      const newData = [[props.editedOption], ...props.data];
      props.setExcelData(newData);
    }
    props.setNewFeatureColumn(false);
  };

  const handleOptionChange = (e) => {
    const newValue = e.target.value.trimStart();
    props.setEditedOption(newValue);
  };

  return (
    <div className="editable-dropdown">
      {props.newFeatureColumn ? (
        <div className={`feature-list selectedOpn`}>
          {" "}
          <input
            placeholder="Add Feature Here!"
            value={props.editedOption}
            onChange={handleOptionChange}
          />
          <div style={{display:"flex", gap:"7px", margin:"4px 4px 0 0"}}>
            {
              (!props.editedOption.length) ? (<button
                className="icon-btn"
                title="Save"
                // onClick={handleAddFeature}
              >
                <img src={save} alt="" draggable={false} />
              </button>):
              ( <button
                className="icon-btn"
                title="Save"
                onClick={handleAddFeature}
              >
                <img src={saveColor} alt="" draggable={false} />
              </button>)
            }
           
            <button className="icon-btn" title="Cancel" onClick={handleCancel}>
              <img src={deleteIco} alt="" draggable={false} />
            </button>
          </div>
        </div>
      ) : (
        ""
      )}
      {props.data.map((option, index) => (
        <>
          <div
            className={`feature-list ${
              props.editMode && selectedOptionIndex === index
                ? "selectedOpn"
                : ""
            }`}
            key={index}
          >
            {props.editMode && selectedOptionIndex === index ? (
              <>
                <input
                  value={props.editedOption}
                  onChange={handleOptionChange}
                />
                <div style={{display:"flex", gap:"7px", margin:"4px 4px 0 0"}}>
                  <button
                    className="icon-btn-save"
                    title="Save"
                    onClick={handleSave}
                  >
                    <img src={saveColor} alt="" draggable={false} />
                  </button>
                  <button
                    className="icon-btn"
                    title="Delete"
                    onClick={() => handleDelete(index)}
                  >
                    {" "}
                    <img src={deleteIcoColor} alt="" draggable={false} />
                  </button>
                  <button
                    className="icon-btn"
                    title="Cancel"
                    onClick={handleCancel}
                  >
                    <img src={deleteIco} alt="" draggable={false} />
                  </button>
                </div>
              </>
            ) : (
              <>
                <span> {option} </span>
                <button
                  className="icon-btn"
                  title="Edit"
                  disabled={props.excelDataId[option]}
                  onClick={() => handleEdit(index)}
                >
                  <img src={edit} alt="" draggable={false} />
                </button>
              </>
            )}
          </div>
          <hr style={{ width: "99%", height: "1px", background: "#E7E7E7" }} />
        </>
      ))}
    </div>
  );
};

export default EditableDropdown;
